import * as React from "react";
import "./App.css";
import { EqLayout } from "./components/shared/EqLayout";
import {
    Route,
    Routes,
    BrowserRouter,
    Navigate,
} from "react-router-dom";
import Logout from "./components/logout/Logout";
import { Home } from "./components/home/Home";
import { FrontEndPoints } from "./components/shared/Common";
import EqTrainerDashboard from "./components/eqTrainer/dashboard/EqTrainerDashboard";
// const EqStudentDashboard = React.lazy(() => import("./components/eqStudent/dashboard/EqStudentDashboard"));
import EqStudentDashboard from "./components/eqStudent/dashboard/EqStudentDashboard";
import EqStudentGroupsBoard from "./components/eqStudent/groupsBoard/EqStudentGroupsBoard";
import EqAdminDashboard from "./components/eqAdmin/dashboard/EqAdminDashboard";

import RoleBasedRoute from "./components/shared/RoleBasedRoute";
import EqTrainerStudentsBoard from "./components/eqTrainer/studentBoard/EqTrainerStudentsBoard";
import EqFinancialsBoard from "./components/eqTrainer/FinancialsBoard/EqFinancialsBoard";
import EqGroupsBoard from "./components/eqTrainer/GroupsBoard/EqGroupsBoard";
import MessageBoard from "./components/eqTrainer/eqMessageBoard/EqMessageBoard";
import Checkout from "./components/eqStudent/checkout/checkout";
import EqStudentFinancialsBoard from "./components/eqStudent/financialsBoard/EqStudentFinancialsBoard";
import EqProfessionalsBoard from "./components/eqTrainer/professionalsBoard/EqProfessionalsBoard";
import EqViewEvent from "./components/eqStudent/viewEvent/EqViewEvent";
import EqAccountCreated from "./components/stripe/accountCreated/EqAccountCreated";
import { AxiosInterceptor } from "./components/shared/Api";
import EqStudentAllTrainings from "./components/eqStudent/studentAllTrainings/EqStudentAllTrainings";
import UpdatePassword from "./components/updatePassword/UpdatePassword";
import EqTrainerProductsBoard from "./components/eqTrainer/trainerProductsBoard/EqTrainerProductsBoard";
import EqTrainerActivityBoard from "./components/eqTrainer/trainerActivityBoard/EqTrainerActivityBoard";
import EqJoinEvent from "./components/eqStudent/eqEventJoin/EqJoinEvent";
import CheckoutGuest from "./components/eqStudent/checkoutGuest/checkoutGuest";
import EqEventPrint from "./components/eqTrainer/EventPrintView/eqEventPrint";
import EqSchoolDashboard from "./components/eqSchool/dashboard/EqSchoolDashboard";
import EqSchoolActivityBoard from "./components/eqSchool/schoolActivityBoard/EqSchoolActivityBoard";
import EqSchoolStudentsBoard from "./components/eqSchool/studentBoard/EqSchoolStudentsBoard";
import EqSchoolTrainersBoard from "./components/eqSchool/trainerBoard/EqSchoolTrainersBoard";
import EditProfile from "./components/editProfile/EditProfile";
import EqSchoolProfileBoard from "./components/eqSchool/schoolProfileBoard/EqSchoolProfileBoard";
import EqRidingSchools from "./components/eqSchool/eqRidingSchools/EqRidingSchools";
import EqEventHolderDashboard from "./components/eqEventHolder/dashboard/EqEventHolderDashboard";
import EqEventHolderActivityBoard from "./components/eqEventHolder/eventHolderActivityBoard/EqEventHolderActivityBoard";
import EqEventHolderProfileBoard from "./components/eqEventHolder/eventHolderprofileBoard/EqEventHolderProfileBoard";
import EqSubscriptionSettings from "./components/eqAdmin/subscriptionSettings/EqSubscriptionSettings";
import Features from "./components/features/Features";
import EqFeatureRidingSchool from "./components/eqStudent/eqFeatureRidingSchool/EqFeatureRidingSchool";
import EqFeatureEventHolder from "./components/eqEventHolder/eqFeatureEventHolder/EqFeatureEventHolder";
import ProfessionalConnections from "./components/eqStudent/eqProfessionalConnections/ProfessionalConnections";
import EqStudentProductBoard from "./components/eqStudent/eqStudentProductBoard/EqStudentProductBoard";
import EqFeatureTrainer from "./components/eqTrainer/eqFeatureTrainer/EqFeatureTrainer";
import EqApproveProfessionals from "./components/eqAdmin/approveProfessionals/EqApproveProfessionals";
import EqSubscriptionProduct from "./components/eqAdmin/subscriptionProduct/EqSubscriptionProduct";
import EqSubscriptionSetting from "./components/eqAdmin/subscriptionSetting/EqSubscriptionSetting";

import { AnimatePresence } from "framer-motion";
import EqTrainerProfileBoard from "./components/eqTrainer/trainerProfileBoard/EqTrainerProfileBoard";
import EqSubscriptions from "./components/eqAdmin/subscriptions/EqSubscriptions";
import { Contact } from "./components/contact/Contact";
import EqEmailReportBoard from "./components/eqAdmin/EmailReportBoard/EqEmailReportBoard";
import EqTrainerInvitationsBoard from "./components/eqTrainer/trainerInvitationsBoard/EqTrainerInvitationsBoard";
import EqSchoolInvitationsBoard from "./components/eqSchool/schoolInvitationsBoard/EqSchoolInvitationsBoard";
import EqTrainerRequestsBoard from "./components/eqTrainer/trainerRequestsBoard/EqTrainerRequestsBoard";

import EqHorseTaskBoard from "./components/custom/eqHorseTaskBoard/EqHorseTaskBoard";
import EqLogin from "./components/eqLogin/EqLogin";
import EqRegister from "./components/eqRegister/EqRegister";
import EqForgetPassword from "./components/eqForgetPassword/EqForgetPassword";
import EqResetPassword from "./components/eqResetPassword/EqResetPassword";
import EqPublicEventList from "./eqComponents/eqPublicEventList/EqPublicEventList";
import EqPublicEventSingle from "./eqComponents/eqPublicEventSingle/EqPublicEventSingle";
import EqPublicEventSucess from "./eqComponents/eqPublicEventSucess/EqPublicEventSucess";
import EqPublicBookingConfirmation from "./eqComponents/eqPublicBookingConfirmation/EqPublicBookingConfirmation";
import TrainingCourseBoard from "./components/eqSchool/trainingCourse/trainingCourseBoard/TrainingCourseBoard";
import EqPublicEventListPage from "./eqComponents/eqPublicEventListPage/EqPublicEventListPage";
import EqSchoolCourseBoard from "./components/eqSchool/schoolCourseBoard/EqSchoolCourseBoard";
import UserManagement from "./components/eqAdmin/userManagment/UserManagement";
import UnsubscribePage from "./eqComponents/UnSubscribePage/UnSubscribePage";
import LogsViewer from "./components/eqAdmin/logsViewer/LogsViewer";
import EmailManagement from "./components/eqAdmin/EmailManagement/EmailManagement";
import EqOnBoarding from "./components/eqOnBoarding/EqOnBoarding";
import EqOwnerProductsBoard from "./components/eqSchool/eqOwnerProductsBoard/EqOwnerProductsBoard";

function App() {

    

    return (
        <BrowserRouter>
            <AxiosInterceptor>
                <AnimatePresence>
                    <Routes>
                        <Route element={<EqLayout />}>

                        <Route
                                path={FrontEndPoints.unSubscribe}
                                element={<UnsubscribePage />}
                            />

                            <Route
                                path={FrontEndPoints.publicEventSingle}
                                element={<EqPublicEventSingle />}
                            />

                            <Route
                                path={FrontEndPoints.allPublicEvents}
                                
                                element={<EqPublicEventListPage />}

                            />
           
                            <Route
                                path={FrontEndPoints.publicEventBookingConfirm}
                                element={<EqPublicBookingConfirmation />}
                            />
                            <Route path={FrontEndPoints.all} element={<Home />} />


                            <Route path={FrontEndPoints.contact} element={<Contact />} />
                            <Route path={FrontEndPoints.login} element={<EqLogin />} />


                            <Route path={FrontEndPoints.features} element={<Features />} />
                            {/* Feature */}
                            <Route
                                path={FrontEndPoints.ridingSchoolFeatures}
                                element={<EqFeatureRidingSchool />}
                            />
                            <Route
                                path={FrontEndPoints.eventHolderFeatures}
                                element={<EqFeatureEventHolder />}
                            />
                            <Route
                                path={FrontEndPoints.trainerFeatures}
                                element={<EqFeatureTrainer />}
                            />
    
                            <Route path={FrontEndPoints.logout} element={<Logout />} />
                          
                            <Route
                                path={FrontEndPoints.forgotPassword}
                                element={<EqForgetPassword />}
                            />
                            <Route
                                path={FrontEndPoints.resetPassword}
                                element={<EqResetPassword />}
                            />
                            <Route
                                path={FrontEndPoints.updatePassword}
                                element={<UpdatePassword />}
                            />

                            <Route
                                path={FrontEndPoints.RidingSchools}
                                element={<EqRidingSchools />}
                            />

                            <Route
                                path={FrontEndPoints.trainer.allProfessionalsBoard}
                                element={<EqProfessionalsBoard />}
                            />

                            <Route
                                path={FrontEndPoints.trainer.profileBoard}
                                element={<EqTrainerProfileBoard />}
                            />

                            <Route
                                path={FrontEndPoints.eventHolder.profileBoard}
                                element={<EqEventHolderProfileBoard />}
                            />

                            <Route
                                path={FrontEndPoints.school.profileBoard}
                                element={<EqSchoolProfileBoard />}
                            />
                            {/* Trainer */}

                            <Route
                                path={FrontEndPoints.student.viewEvent}
                                element={<EqViewEvent />}
                            />
                            <Route
                                path={FrontEndPoints.student.joinEvent}
                                element={<EqJoinEvent />}
                            />
                            <Route path={FrontEndPoints.register} element={<EqRegister />} />

                            <Route
                                path={FrontEndPoints.guestCheckout}
                                element={<CheckoutGuest />}
                            />

                            <Route
                                path={FrontEndPoints.trainer.eventPrint}
                                element={<EqEventPrint />}
                            />
                         

                        </Route>

                        <Route element={<RoleBasedRoute />}>

                            <Route path={FrontEndPoints.eventSuccess}
                                element={<EqPublicEventSucess />} />



                            <Route
                                path={FrontEndPoints.trainer.accountCreated}
                                element={<EqAccountCreated />}
                            />

                            <Route
                                path={FrontEndPoints.admin.subscriptionProduct}
                                element={<EqSubscriptionProduct />}
                            />

                            <Route
                                path={FrontEndPoints.admin.subscriptionSetting}
                                element={<EqSubscriptionSetting />}
                            />

                            <Route
                                path={FrontEndPoints.admin.subscription}
                                element={<EqSubscriptions />}
                            />

                            <Route
                                path={FrontEndPoints.admin.subscriptionSettings}
                                element={<EqSubscriptionSettings />}
                            />
                         
                            <Route
                                path={FrontEndPoints.admin.emailReport}
                                element={<EqEmailReportBoard />}
                            />

                            <Route
                                path={FrontEndPoints.student.editProfile}
                                element={<EditProfile />}
                            />
                            <Route
                                path={FrontEndPoints.student.dashboard}
                                element={<EqStudentDashboard />}
                            />
                            <Route
                                path={FrontEndPoints.student.allTrainings}
                                element={<EqStudentAllTrainings />}
                            />
                            <Route
                                path={FrontEndPoints.student.allProfessionalsBoard}
                                element={<EqProfessionalsBoard />}
                            />
                         

  
                            {/* <Route
                                path={FrontEndPoints.student.schedule}
                                element={<EqStudentScheduleList />}
                            /> */}
     
                            <Route
                                path={FrontEndPoints.student.productBoard}
                                element={<EqStudentProductBoard />}
                            />
                            <Route
                                path={FrontEndPoints.student.publicEvents}
                                element={<EqPublicEventList />}
                            />

                           
                        
                            <Route
                                path={FrontEndPoints.student.paymentBoard}
                                element={<EqStudentFinancialsBoard />}
                            />
                     
                       
                            <Route
                                path={FrontEndPoints.student.connection}
                                element={<ProfessionalConnections />}
                            />

                         
                            <Route
                                path={FrontEndPoints.admin.dashboard}
                                element={<EqAdminDashboard />}
                            />
         
                            <Route
                                path={FrontEndPoints.admin.approveProfessionals}
                                element={<EqApproveProfessionals />}
                            />
                              <Route
                                path={FrontEndPoints.admin.userManagement}
                                element={<UserManagement />}
                            />
                              <Route
                                path={FrontEndPoints.admin.emailManagement}
                                element={<EmailManagement />}
                            />
                              <Route
                                path={FrontEndPoints.admin.logs}
                                element={<LogsViewer />}
                            />
                          
                          
                            <Route
                                path={FrontEndPoints.trainer.dashboard}
                                element={<EqTrainerDashboard />}
                            />
                            <Route
                                path={FrontEndPoints.trainer.editTrainer}
                                element={<EditProfile />}
                            // edit trainer profile
                            />
             
                            <Route
                                path={FrontEndPoints.trainer.studentBoard}
                                element={<EqTrainerStudentsBoard />}
                            />
                            
                            <Route
                                path={FrontEndPoints.student.groupBoard}
                                element={<EqStudentGroupsBoard />}
                            />
                          
                           
                          <Route
                                path={FrontEndPoints.student.messageBoard}
                                element={<MessageBoard />}

                            />
                            <Route
                                path={FrontEndPoints.student.checkout}
                                element={<Checkout />}
                            />
 <Route path={FrontEndPoints.student.trainingCourse}
                                element={<TrainingCourseBoard />} 
                                />
                            <Route
                                path={FrontEndPoints.trainer.productBoard}
                                // element={<EqTrainerProductsBoard />}
                                element={<EqOwnerProductsBoard />}
                            />
                            <Route
                                path={FrontEndPoints.trainer.activityBoard}
                                element={<EqTrainerActivityBoard />}
                            />
        
                            <Route
                                path={FrontEndPoints.trainer.professionalsBoard}
                                element={<EqProfessionalsBoard />}
                            />
                          
                            <Route
                                path={FrontEndPoints.trainer.invitations}
                                element={<EqTrainerInvitationsBoard />}
                            />
                            <Route
                                path={FrontEndPoints.trainer.horseBoard}
                                element={<EqHorseTaskBoard />}
                            />

                            <Route
                                path={FrontEndPoints.trainer.requests}
                                element={<EqTrainerRequestsBoard />}
                            />
                           
                         
                        
                            <Route
                                path={FrontEndPoints.trainer.groupsBoard}
                                element={<EqGroupsBoard />}
                            />
                            <Route
                                path={FrontEndPoints.trainer.messageBoard}
                                element={<MessageBoard />}
                            />
                           
                            <Route
                                path={FrontEndPoints.trainer.paymentBoard}
                                element={<EqFinancialsBoard />}
                            />

                            {/* Event Holder Routes */} /************************************************************ */
                            <Route
                                path={FrontEndPoints.eventHolder.dashboard}
                                element={<EqEventHolderDashboard />}
                            />
                            <Route
                                path={FrontEndPoints.eventHolder.editEventHolder}
                                element={<EditProfile />}
                            />

                            <Route
                                path={FrontEndPoints.eventHolder.activityBoard}
                                element={<EqEventHolderActivityBoard />}
                            />

                            {/* school Routes */} /****************************************************************** */

                            <Route
                                path={FrontEndPoints.school.groupsBoard}
                                element={<EqGroupsBoard />}
                            />
                            <Route
                                path={FrontEndPoints.school.editSchool}
                                element={<EditProfile />}
                            />
                            <Route
                                path={FrontEndPoints.school.dashboard}
                                element={<EqSchoolDashboard />}
                            />
                            <Route
                                path={FrontEndPoints.school.onboarding}
                                element={<EqOnBoarding />}
                            />
                            <Route
                                path={FrontEndPoints.school.activityBoard}
                                element={<EqSchoolActivityBoard />}
                            />

                            <Route
                                path={FrontEndPoints.school.productBoard}
                                element={<EqOwnerProductsBoard />}
                            />
                            <Route path={FrontEndPoints.school.trainingCourse}
                                element={<EqSchoolCourseBoard />} />
                           
                           
                           
                            <Route
                                path={FrontEndPoints.school.studentBoard}
                                element={<EqSchoolStudentsBoard />}
                            />
                            <Route
                                path={FrontEndPoints.school.trainerBoard}
                                element={<EqSchoolTrainersBoard />}
                            />

                            <Route
                                path={FrontEndPoints.school.paymentBoard}
                                element={<EqFinancialsBoard />}
                            />
                         
                            <Route
                                path={FrontEndPoints.school.horseBoard}
                                element={<EqHorseTaskBoard />}
                            />
                            <Route
                                path={FrontEndPoints.school.invitations}
                                element={<EqSchoolInvitationsBoard />}
                            />
                            <Route
                                path={FrontEndPoints.school.requests}
                                element={<EqTrainerRequestsBoard />}
                            />
                            <Route
                                path={FrontEndPoints.school.messageBoard}
                                element={<MessageBoard />}
                            />
                        </Route>

                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </AnimatePresence>
            </AxiosInterceptor>
        </BrowserRouter>
    );
}

export default App;
